import React, { useState, useEffect, useContext } from "react";
import {
  setStatusFilter,
  setSearchTerm,
  setProjectTypeFilter,
} from "../../../redux/slices/opportunitiesdata";

import { useMsal } from "@azure/msal-react";
import { useSelector, useDispatch } from "../../../redux/store";
import AdminContext from "../../../Context/adminContext";
import SearchBar from "../../../Components/SearchBar/SearchBar";

import Dropdown from "../../../Components/DropDownBox/Dropdown";

import styles from "./Opportunities.module.css";
import { Box, CircularProgress } from "@mui/material";

import {
  setinputValue,
  setCurrentPage,
  setSortDirection,
  setSortColumn,
  getConfiguration,
  getRunners,
  getOpportunities,
  createOpportunity,
  hasError,
} from "../../../redux/slices/opportunitiesdata";
import { checkPostcodeExists } from "../../../redux/slices/project";

import OppForm from "../../../Components/OppForms/OppForm";
import ApiResponseDisplay from "../../../Components/ApiResponseDisplay/ApiResponseDisplay";
import OppListTable from "../../../Sections/opportunities/OppListTable";
import ProjectTablePagination from "../../Projects/ProjectList/ProjectTablePagination";
import { PostcodeWarningPopUp } from "../../../Components/ConfirmationPopUp/ConfirmationPopUp";

function Opportunities() {
  const { accounts } = useMsal();
  const dispatch = useDispatch();
  const account = accounts[0];

  const admin = useContext(AdminContext);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [postcodeWarningOpen, setPostcodeWarningOpen] = useState(false);
  const [postcodeWarningData, setPostcodeWarningData] = useState(null);
  const [pendingFormData, setPendingFormData] = useState(null);

  const {
    opportunities,
    inputValue,
    isOppListLoading,
    isNewOppLoading,
    isConfigLoading,
    error,
  } = useSelector((state) => state.opportunities);
  const [paginationLoading, setPaginationLoading] = useState(false);
  const [isResponseShown, setIsResponseShown] = useState(false);

  const [rowsPerPage, setRowsPerPage] = useState(50);
  const searchTerm = useSelector((state) => state.opportunities.searchTerm);
  const statusFilter = useSelector((state) => state.opportunities.statusFilter);
  const projectTypeFilter = useSelector((state) => state.opportunities.projectTypeFilter);
  const sortDirection = useSelector((state) => state.opportunities.sortDirection);
  const sortColumn = useSelector((state) => state.opportunities.sortColumn);
  const currentPage = useSelector((state) => state.opportunities.currentPage);
  let scrollPos = useSelector((state) => state.opportunities.scrollPos);

  const totalPages = opportunities.totalRows > 0 ? Math.ceil(opportunities.totalRows / rowsPerPage) : 0;
  const currentPageValue = opportunities.totalRows > 0 ? currentPage : 0;

  useEffect(() => {
    dispatch(getOpportunities(
      statusFilter.toLowerCase(),
      currentPage,
      50,
      searchTerm.toLowerCase(),
      sortColumn,
      sortDirection,
      projectTypeFilter.toLowerCase()
    ));
    dispatch(getConfiguration());
    dispatch(getRunners());
    setPaginationLoading(false);
  }, [statusFilter, searchTerm, currentPage, sortColumn, sortDirection, projectTypeFilter]);

  useEffect(() => {
    if (error && isResponseShown === false && error !== null) {
      console.log("WORKING");
      setIsResponseShown(true);
    }
  }, [error]);

  const handleFormSubmit = async (formData) => {
    console.log("Form Data Submitted:", formData);

    const modifiedFormData = {
      ...formData,
      formType: "project_fee", // Add 'formType' key with value 'project_fee'
      completedBy: account.username, // Add 'completedBy' key with value 'account'
    };

    // Check for postcode existence first
    if (modifiedFormData.postcode) {
      const postcodeCheckResult = await dispatch(checkPostcodeExists(modifiedFormData.postcode));

      if (postcodeCheckResult.exists) {
        // Show warning dialog
        setPostcodeWarningData({
          postcode: modifiedFormData.postcode,
          existingProjects: postcodeCheckResult.projects
        });
        setPendingFormData(modifiedFormData);
        setPostcodeWarningOpen(true);
        return; // Don't proceed with creation yet
      }
    }

    // No postcode conflict or no postcode provided, proceed with creation
    dispatch(createOpportunity(modifiedFormData));
  };

  const handlePostcodeWarningContinue = () => {
    setPostcodeWarningOpen(false);
    // Continue with opportunity creation
    dispatch(createOpportunity(pendingFormData));
    setPendingFormData(null);
    setPostcodeWarningData(null);
  };

  const handlePostcodeWarningCancel = () => {
    setPostcodeWarningOpen(false);
    setPendingFormData(null);
    setPostcodeWarningData(null);
  };

  const openOppForm = () => () => {
    setModalIsOpen(true);
  };

  const handleSort = (column) => {
    if (column === sortColumn) {
      dispatch(setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc'));
    } else {
      dispatch(setSortColumn(column));
      dispatch(setSortDirection('asc'));
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setPaginationLoading(true);
      dispatch(setCurrentPage(currentPage - 1));
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setPaginationLoading(true);
      dispatch(setCurrentPage(currentPage + 1));
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages && pageNumber !== currentPage) {
      setPaginationLoading(true);
      dispatch(setCurrentPage(pageNumber));
    }
  };

  const handlestatusFilter = (service) => {
    dispatch(setStatusFilter(service));
  };

  const handleProjectTypeFilter = (companyProject) => {
    dispatch(setProjectTypeFilter(companyProject));
  };

  const handleSearch = (event) => {
    dispatch(setinputValue(event.target.value));
  };

  const handleSearchSubmit = () => {
    dispatch(setSearchTerm(inputValue));
    dispatch(setCurrentPage(1));
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearchSubmit();
    }
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <div className={styles.OpportunitiesMainContent}>
      <div className={styles.Header}>
        <div className={styles.OpportunitiesTitle}>Opportunities</div>
      </div>

      <div className={styles.OpportunitiesTableFilters}>
        <div className={styles.Filters}>
          <div className={styles.statusFilter}>
            <label
              className={styles.FilterLabel}
              htmlFor="statusFilter"
              style={{ fontSize: "12px" }}
            >
              Status:
            </label>
            <div className={styles.dropdownContainer}>
              <Dropdown
                options={["All", "Open", "Lost"]}
                initialSelectedValue={statusFilter}
                onValueChange={handlestatusFilter}
                disabled={isOppListLoading}
              />
            </div>
          </div>
          <div className={styles.statusFilter} style={{ marginLeft: "20px" }}>
            <label
              className={styles.FilterLabel}
              htmlFor="projectTypeFilter"
              style={{ fontSize: "12px" }}
            >
              Type:
            </label>
            <div className={styles.dropdownContainer}>
              <Dropdown
                options={["All", "Blue", "Re-S"]}
                initialSelectedValue={projectTypeFilter}
                onValueChange={handleProjectTypeFilter}
                disabled={isOppListLoading}
              />
            </div>
          </div>
        </div>

        <div className={styles.SearchBar}>
          {admin && (
            <React.Fragment>
              <div
                className={`${styles.AddBtn} ${isOppListLoading ? styles.AddDisabled : ""
                  }`}
                onClick={openOppForm()}
              >
                FP FORM
              </div>
            </React.Fragment>
          )}
          <SearchBar value={inputValue} onChange={handleSearch} onKeyDown={handleKeyDown} disabled={isOppListLoading} onClick={handleSearchSubmit} />
        </div>
      </div>

      {isOppListLoading || isConfigLoading || isNewOppLoading && (
        <div className="ProfileHolidayOverlay">
          <div
            className="ProfileHolidayResponseBox"
            style={{ borderRadius: "150px", minWidth: "160px" }}
          >
            <CircularProgress size={65} />
          </div>
        </div>
      )}
      {!isOppListLoading && !isConfigLoading && !isNewOppLoading && (
        <>
          {modalIsOpen && (
            <OppForm onSubmit={handleFormSubmit} onClose={closeModal} />
          )}
          {postcodeWarningOpen && postcodeWarningData && (
            <PostcodeWarningPopUp
              isVisible={postcodeWarningOpen}
              onClose={handlePostcodeWarningCancel}
              onContinue={handlePostcodeWarningContinue}
              postcode={postcodeWarningData.postcode}
              existingProjects={postcodeWarningData.existingProjects}
            />
          )}
        </>
      )}
      {isOppListLoading ? (
        <>
          <OppListTable
            rows={[]}
            loading={isOppListLoading}
            handleSort={handleSort}
            sortDirection={sortDirection}
            sortColumn={sortColumn}
          />


          <ProjectTablePagination
            currentPage={currentPageValue}
            totalPages={totalPages}
            onPrevPage={paginationLoading ? null : handlePrevPage} // disable if loading
            onNextPage={paginationLoading ? null : handleNextPage} // disable if loading
            rowsShown={opportunities.rows.length}
            totalRows={opportunities.totalRows}
            rowsPerPage={rowsPerPage}
            loading={isOppListLoading}
            onPageChange={handlePageChange}
          />
        </>
      ) : (
        <>
          <OppListTable
            rows={opportunities.rows}
            sortColumn={sortColumn}
            sortDirection={sortDirection}
            handleSort={handleSort}
            loading={isOppListLoading}
            onPageChange={handlePageChange}
          />

          <div className='ProjectPagination'>
            <ProjectTablePagination
              currentPage={currentPageValue}
              totalPages={totalPages}
              onPrevPage={paginationLoading ? null : handlePrevPage} // disable if loading
              onNextPage={paginationLoading ? null : handleNextPage} // disable if loading
              rowsShown={opportunities.rows.length}
              totalRows={opportunities.totalRows}
              rowsPerPage={rowsPerPage}
              loading={isOppListLoading}
              onPageChange={handlePageChange}
            />
          </div>

        </>
      )}
      {isResponseShown && error && error !== null && (
        <ApiResponseDisplay
          apiResponse={error}
          setIsResponseShown={setIsResponseShown}
          onClose={() => dispatch(hasError(null))}
        />
      )}
    </div>
  );
}

export default Opportunities;
